import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

export interface PersonAttributesData {
  personUuid: string;
  personAttributes: {
    [key: string]: string | number | boolean;
  };
}

export const getPersonInfo = async (): Promise<AxiosResponse> => {
  return await jwtApiClient.get(M3_API().GET_PERSON_INFO, {
    params: {},
  });
};

export const storePersonAttributes = async (
  payload: PersonAttributesData
): Promise<AxiosResponse> => {
  return await jwtApiClient.post(M3_API().STORE_PERSON_ATTRIBUTES, payload);
};

export const getPersonAttributes = async (
  cartTag: string
): Promise<AxiosResponse> => {
  return await jwtApiClient.get(M3_API(cartTag).GET_PERSON_ATTRIBUTES);
};

export const getPersonFraudAssessment = async (
  cartTag: string
): Promise<AxiosResponse> => {
  return await jwtApiClient.get(M3_API(cartTag).GET_PERSON_FRAUD_ASSESSMENT, {
    params: {},
  });
};
